import React, {
  useEffect,
  useState,
  useCallback
} from "react";


import {
  Box,
  Checkbox,
  FormControlLabel,
  DialogContentText,
  Snackbar,
  Alert,
} from "@mui/material";


import AddIcon from "@mui/icons-material/Add";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";


import AppButton from "../ui/AppButton";
import PageHeader from "../ui/PageHeader";
import DeleteDialog from "../modals/DeleteDialog";
import TicketTable from "../components/tickets/TicketTable";
import TicketDialog from "../components/tickets/TicketDialog";
import TicketFilters from "../components/tickets/TicketFilters";


import {
  getTickets,
  createTicket,
  updateTicket,
  deleteTicket,
} from "../services/ticketService";
import { useUserRole } from "../context/UserRoleContext";
import { USER_ROLES } from "../auth/roles";


function Tickets(){



const [tickets,setTickets] = useState([]);

const [loading,setLoading] = useState(false);



// FILTER STATES

const [search,setSearch] = useState("");

const [status,setStatus] = useState("");

const [priority,setPriority] = useState("");

const [category,setCategory] = useState("");

const [sortBy,setSortBy] = useState("");





const [dialogOpen,setDialogOpen] = useState(false);

const [isSaving,setIsSaving] = useState(false);

const [deleteOpen,setDeleteOpen] = useState(false);

const [isDeleting,setIsDeleting] = useState(false);
const [isBulkDeleting,setIsBulkDeleting] = useState(false);
const [bulkDeleteOpen,setBulkDeleteOpen] = useState(false);
const [deleteRelated,setDeleteRelated] = useState(false);
const [selectedTicketIds,setSelectedTicketIds] = useState([]);


const [selectedTicket,setSelectedTicket] = useState(null);






const [snackbar,setSnackbar] = useState({

open:false,

message:"",

severity:"success"

});

const {
  role,
  employee,
  loading: roleLoading
} = useUserRole();









const loadTickets = useCallback(async()=>{


try{


setLoading(true);



const data = await getTickets(

search,

status,

priority,

category,

sortBy,

role === USER_ROLES.SUPER_ADMIN
? null
: (employee?.employee_id ?? -1)

);



setTickets(data);

setSelectedTicketIds((prev) => {
  const validIds = new Set(data.map((ticket) => ticket.ticket_id));
  return prev.filter((id) => validIds.has(id));
});



}

catch(error){


console.error(

"Ticket Load Error:",

error.response?.data || error

);



setSnackbar({

open:true,

message:"Failed to load tickets",

severity:"error"

});


}


finally{


setLoading(false);


}



},[

search,

status,

priority,

category,

sortBy,

role,

employee

]);









useEffect(()=>{

if(roleLoading){
  return;
}


loadTickets();


},[loadTickets, roleLoading]);









const handleSave = async(data)=>{

if(isSaving){
return;
}

try{

setIsSaving(true);

if(selectedTicket){



await updateTicket(

selectedTicket.ticket_id,

data

);



}

else{


const creatorEmployeeId = data.created_by || employee?.employee_id;

if(!creatorEmployeeId){
  throw new Error("Unable to resolve logged-in employee. Please map your login email to an employee record.");
}



await createTicket({

...data,

created_by:creatorEmployeeId

});



}





await loadTickets();



setDialogOpen(false);

setSelectedTicket(null);




setSnackbar({

open:true,

message:"Ticket saved successfully",

severity:"success"

});




}

catch(error){



console.error(

"Ticket Save Error:",

error.response?.data || error

);

const message = (
error?.response?.data?.detail
|| error?.message
|| "Operation failed"
);



setSnackbar({

open:true,

message,

severity:"error"

});


}

finally{

setIsSaving(false);

}



};









const handleDelete = async()=>{

if(!selectedTicket || isDeleting){
return;
}

const closeDeleteDialog = ()=>{
setDeleteOpen(false);
setSelectedTicket(null);
setDeleteRelated(false);
};


try{

setIsDeleting(true);


await deleteTicket(

  selectedTicket.ticket_id,

  deleteRelated

);

closeDeleteDialog();




await loadTickets();




setSnackbar({

open:true,

message:deleteRelated
? "Ticket and related records deleted successfully"
: "Ticket deleted successfully",

severity:"success"

});



}

catch(error){



console.error(

"Delete Error:",

error.response?.data || error

);

closeDeleteDialog();


const message = (
error?.response?.data?.detail
|| "Delete failed"
);



setSnackbar({

open:true,

message,

severity:"error"

});


}

finally{

setIsDeleting(false);

}



};




const handleBulkDelete = async()=>{

if(selectedTicketIds.length === 0 || isBulkDeleting){
return;
}

try{

setIsBulkDeleting(true);

let successCount = 0;
let failedCount = 0;

for(const ticketId of selectedTicketIds){
try{
await deleteTicket(ticketId, true);
successCount += 1;
}catch(error){
failedCount += 1;
}
}

setBulkDeleteOpen(false);
await loadTickets();
setSelectedTicketIds([]);

setSnackbar({
open:true,
message:failedCount === 0
? `${successCount} ticket(s) deleted successfully`
: `${successCount} deleted, ${failedCount} failed`,
severity:failedCount === 0 ? "success" : "warning"
});

}catch(error){

console.error("Bulk Delete Error:", error);
setBulkDeleteOpen(false);
setSnackbar({
open:true,
message:"Bulk delete failed",
severity:"error"
});

}finally{

setIsBulkDeleting(false);

}

};









return (


<Box

sx={{

bgcolor:"background.default",

minHeight:"100vh",


p:3

}}

>






{/* HEADER */}

<PageHeader
  title="Tickets"
  subtitle="Manage and track all IT support requests."
  actions={(
    <>
      <AppButton
        variant="outlined"
        color="error"
        startIcon={<DeleteSweepIcon />}
        loading={isBulkDeleting}
        onClick={()=>setBulkDeleteOpen(true)}
        disabled={selectedTicketIds.length === 0}
      >
        {isBulkDeleting ? "Deleting..." : `Delete All (${selectedTicketIds.length})`}
      </AppButton>

      <AppButton
        variant="contained"
        startIcon={<AddIcon/>}
        onClick={()=>{
          setSelectedTicket(null);
          setDialogOpen(true);
        }}
      >
        Create Ticket
      </AppButton>
    </>
  )}
/>









{/* FILTERS */}



<TicketFilters


search={search}

setSearch={setSearch}


status={status}

setStatus={setStatus}


priority={priority}

setPriority={setPriority}


category={category}

setCategory={setCategory}


sortBy={sortBy}

setSortBy={setSortBy}



onApply={loadTickets}




onReset={()=>{


setSearch("");

setStatus("");

setPriority("");

setCategory("");

setSortBy("");

loadTickets();


}}


/>









{/* TABLE */}



<TicketTable


tickets={tickets}


loading={loading}


selectedIds={selectedTicketIds}
onSelectionChange={setSelectedTicketIds}



onEdit={(ticket)=>{


setSelectedTicket(ticket);

setDialogOpen(true);


}}



onDelete={(ticket)=>{


setSelectedTicket(ticket);

setDeleteRelated(false);

setDeleteOpen(true);


}}


/>



<DeleteDialog
open={bulkDeleteOpen}
onClose={()=>{
if(!isBulkDeleting){
setBulkDeleteOpen(false);
}
}}
onConfirm={handleBulkDelete}
isDeleting={isBulkDeleting}
title="Delete Selected Tickets"
message="Are you sure you want to delete all selected tickets?"
itemName={`Selected: ${selectedTicketIds.length}`}
extra={(
  <DialogContentText sx={{ mt: 1 }}>
    This will remove related records for each selected ticket.
  </DialogContentText>
)}
confirmLabel="Delete All"
/>









{/* CREATE / UPDATE */}



<TicketDialog


open={dialogOpen}


ticket={selectedTicket}

deleteRelated={deleteRelated}

onToggleDeleteRelated={setDeleteRelated}

isSaving={isSaving}



onClose={()=>{

if(isSaving){
return;
}

setDialogOpen(false);

setSelectedTicket(null);


}}



onSave={handleSave}


/>









{/* DELETE */}

<DeleteDialog

open={deleteOpen}

isDeleting={isDeleting}

title="Delete Ticket"

message="Are you sure you want to delete this ticket?"

itemName={selectedTicket?.title}

extra={(
  <FormControlLabel
    sx={{ mt: 1 }}
    control={(
      <Checkbox
        checked={deleteRelated}
        onChange={(event) => setDeleteRelated(event.target.checked)}
        disabled={isDeleting}
      />
    )}
    label="Delete all related records"
  />
)}

onClose={()=>{

if(isDeleting){
return;
}


setDeleteOpen(false);

setSelectedTicket(null);

setDeleteRelated(false);


}}



onConfirm={handleDelete}


/>









{/* MESSAGE */}



<Snackbar


open={snackbar.open}


autoHideDuration={4000}



onClose={()=>setSnackbar({

...snackbar,

open:false

})}



>


<Alert severity={snackbar.severity}>


{snackbar.message}


</Alert>


</Snackbar>









</Box>


);


}



export default Tickets;